module.exports = "/img/27 (Personalizado).a7c5f5.webp";